import api from '../../shared/api/client';
import { API_ROUTES } from '../../shared/api/routes';

export const vehicleApi = {
  getVehicles: (params) => api.get(API_ROUTES.vehicles.base, { params }),
  exportVehicles: (data) => api.post(API_ROUTES.vehicles.export, data),
  getVehicle: (id, params) => api.get(API_ROUTES.vehicles.detail(id), { params }),
  createVehicle: (userId, data) =>
    api.post(API_ROUTES.vehicles.base, {
      userId,
      societyId: data?.societyId,
      ...data,
    }),
  updateVehicle: (id, data, params) => api.put(API_ROUTES.vehicles.detail(id), data, { params }),
  updateVehicleStatus: (id, data, params) => api.patch(API_ROUTES.vehicles.status(id), data, { params }),
  updateVehicleAccess: (id, data) => api.patch(API_ROUTES.vehicles.access(id), data),
  evaluateRequirements: (data) => api.post(API_ROUTES.vehicles.requirements, data),
  uploadRegistrationCertificate: (id, data, params) =>
    api.post(API_ROUTES.vehicles.registrationCertificate(id), data, { params }),
  sendMapExistingOtp: (data) => api.post(API_ROUTES.vehicles.mapExistingOtp, data),
  mapExistingVehicle: (data) => api.post(API_ROUTES.vehicles.mapExisting, data),
};

export const vehicleOwnerApi = {
  updateOwner: (userId, data, params) => api.put(API_ROUTES.users.detail(userId), data, { params }),
};
